<template>
  <div style="margin: 0 auto;width: 100%;">
    <Header/>
    <ActivityHead/>
    <ActivityNotice/>
    <Footer/>
  </div>
</template>

<script>
import Header from './components/Header'
import ActivityHead from './components/ActivityHead'
import ActivityNotice from './components/ActivityNotice'
import Footer from './components/Footer'
export default {
  components: {
    Header,
    ActivityHead,
    ActivityNotice,
    Footer
  },
  data () {
    return {
      programId: Number(this.$route.query.programId)
    }
  },
  created () {
  },
  methods: {
  }
}
</script>
<style lang="scss" scoped>

</style>



// WEBPACK FOOTER //
// src/daoba-match/views/program/ActivityNotice.vue